/*
IAS (Integral Ad Science) PET (Publisher Engagement Tracking) setup.
This module configures viewability and brand safety tracking for ad slots.

IAS PET needs to:
1. Wait for cookie consent (GDPR requirement)
2. Wait for all ad slots to be defined
3. Send ad slot configurations to IAS for tracking
4. Handle the response and set targeting for GPT
*/

export const refreshAdsWithIAS = (slotRefresh) => {
  // Initialize IAS PET global object
  window.__iasPET = window.__iasPET || {};
  window.__iasPET.queue = window.__iasPET.queue || [];
  window.__iasPET.pubId = '931015'; // Autovia's IAS Publisher ID

  // Timeout fallback: if IAS doesn't respond, still refresh ads
  const IASPET_TIMEOUT = 2000;
  const iasPETTimeoutRequestAds = setTimeout(() => {
    slotRefresh();
  }, IASPET_TIMEOUT);

  // Data handler: called when IAS returns tracking data
  const iasDataHandler = function(_adSlotData) {
    clearTimeout(iasPETTimeoutRequestAds);

    if (window.__iasPET.setTargetingForGPT) {
      window.__iasPET.setTargetingForGPT();
    } else {
      console.warn('[IAS PET] setTargetingForGPT not available');
    }

    slotRefresh();
  };

  // Wait for ad slots to be fully defined, then configure IAS PET
  setTimeout(() => {
    const gptSlots = window.googletag.pubads().getSlots() || [];

    // Only proceed if there are actual ad slots
    if (!gptSlots || gptSlots.length === 0) {
      clearTimeout(iasPETTimeoutRequestAds);
      return;
    }

    // Build IAS PET slot configurations from GPT slots
    const iasPETSlots = gptSlots.map((slot) => {
      const sizes = slot.getSizes().map((size) => {
        if (size.getWidth && size.getHeight) {
          return [size.getWidth(), size.getHeight()];
        }
        return [1, 1]; // Fallback for fluid/responsive sizes
      });

      return {
        adSlotId: slot.getSlotElementId(),
        // size: can either be a single size (for example, [728, 90])
        // or an array of sizes (for example, [[728, 90], [970, 90]])
        size: sizes,
        adUnitPath: slot.getAdUnitPath(),
      };
    });

    // Queue the PET request
    window.__iasPET.queue.push({
      adSlots: iasPETSlots,
      dataHandler: iasDataHandler,
    });
  }, 100); // 100ms delay to ensure all slot definitions are processed
};

